'use client';

import { createLogger } from './createLogger';
import { censorLoggedValue } from './telemetryDenylist';

function writeCensored(level: 'debug' | 'info' | 'warn' | 'error') {
  return (entry: object) => {
    const target = console[level] ?? console.log;
    target(censorLoggedValue(entry));
  };
}

/**
 * creates a client friendly logger
 */
export const logger = createLogger({
  options: {
    browser: {
      asObject: true,
      write: {
        debug: writeCensored('debug'),
        info: writeCensored('info'),
        warn: writeCensored('warn'),
        error: writeCensored('error'),
        fatal: writeCensored('error'),
        trace: writeCensored('debug'),
      },
    },
  },
});
